// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtEnrollmentUpdateRequestModel {
    static getAttributeTypeMap() {
        return ExtEnrollmentUpdateRequestModel.attributeTypeMap;
    }
}
ExtEnrollmentUpdateRequestModel.discriminator = undefined;
ExtEnrollmentUpdateRequestModel.additionalProperties = false;
ExtEnrollmentUpdateRequestModel.attributeTypeMap = [
    {
        "name": "insuranceVerification",
        "baseName": "insuranceVerification",
        "type": "ExtEnrollmentInsuranceVerificationModel"
    },
    {
        "name": "demographics",
        "baseName": "demographics",
        "type": "ExtEnrollmentDemographicsModel"
    },
    {
        "name": "clientIdentifiers",
        "baseName": "clientIdentifiers",
        "type": "ExtEnrollmentClientIdentifiersModel"
    },
];
//# sourceMappingURL=extEnrollmentUpdateRequestModel.js.map